import {useSelector} from 'react-redux';
import {AppState} from '../../redux';
import {VisuallyImpairedSettings} from '../models/visuallyImpairedSettings';
import {getFormValues} from 'redux-form';
import {Forms} from '../models/forms';

export const useVisuallyImpairedState = (): VisuallyImpairedSettings => {
  return useSelector<AppState, VisuallyImpairedSettings>(
    (state) => getFormValues(Forms.visuallyImpaired)(state) as VisuallyImpairedSettings,
  );
};
